import React from 'react';
import Navbar from '../layout/Navbar';
import CorporateWellbeingSection from './CorporateWellbeingSection';
import ContactSection from '../home/ContactSection';
import Footer from '../layout/Footer';
import GlobalStyles from '../layout/GlobalStyles';

const CorporateWellbeingPage = () => {
  return (
    <>
      <GlobalStyles />
      <Navbar />
      <CorporateWellbeingSection />
      <ContactSection />
      <Footer />
    </>
  );
};

export default CorporateWellbeingPage;